const PAYMENT = 'payment';
export default PAYMENT;
